import classes from "./RecordKiosk.module.css"
import {useEffect, useState} from "react";
import arrow from "../../../store/arrow.png"
import { assetsBaseUrl } from "../../../routes";

const RecordKiosk = (props) => {

    const initialHasLogo = !!(props.path && typeof props.path === 'string' && props.path.trim() !== '');
    const [logo, setLogo] = useState(initialHasLogo ? `${assetsBaseUrl}${props.path}` : null);
    const [hasLogo, setHasLogo] = useState(initialHasLogo);
    const [text, setText] = useState(props.text)
    const [room, setRoom] = useState(props.room)
    const [arrowDir, setArrowDir] = useState(props.pointer)
    const [time, setTime] = useState(props.timeslot)

    useEffect(() => {
        const valid = !!(props.path && typeof props.path === 'string' && props.path.trim() !== '');
        setHasLogo(valid);
        setLogo(valid ? `${assetsBaseUrl}${props.path}` : null);
    }, [props.path])

    useEffect(() => {
        setArrowDir(props.pointer);
    }, [props.pointer]);

//console.error("arr", arrowDir)
    return <div className={`${classes.main} ${text.length > 50 && classes.spaceUp}`}>
        <div className={`${classes.box} ${classes.imgbox}`}>
            {hasLogo && logo && (
                <img
                    src={logo}
                    alt={""}
                    onError={() => {
                        // Když obrázek nejde načíst, schovat logo úplně
                        setHasLogo(false);
                        setLogo(null);
                    }}
                />
            )}
        </div>
        <div className={`${classes.box} ${classes.textbox}`}>
            <div className={classes.text}>{text}</div>
            <div className={classes.room}>{room}</div>
        </div>
        <div className={`${classes.box} ${classes.arrowbox}`}>
            {Number.isFinite(Number(arrowDir)) && Number(arrowDir) >= 1 && Number(arrowDir) <= 8 ? (
                <img
                    className={
                        arrowDir === 1 ? classes.left :
                            arrowDir === 2 ? classes.leftUp :
                                arrowDir === 3 ? classes.up :
                                    arrowDir === 4 ? classes.rightUp :
                                        arrowDir === 5 ? classes.right :
                                            arrowDir === 6 ? classes.rightDown :
                                                arrowDir === 7 ? classes.down :
                                                    arrowDir === 8 ? classes.leftDown : null
                    }
                    src={arrow}
                    alt={"a"}
                />
            ) : null}
        </div>
        <div className={`${classes.box} ${classes.timebox}`}>{time}</div>
    </div>
}

export default RecordKiosk